import { Injectable, OnDestroy } from '@angular/core';
import { Tooltip } from '@com-delta-omnichannel/mach-core-js';

@Injectable()
export class LoginHeaderHelperComponent implements OnDestroy {
  private tooltips = new Map<string, Tooltip>();
  private autoCloseTimer?: ReturnType<typeof setTimeout>;
  signupCondition = false;
  loginCondition = false;
  accountRecoveryCondition = false;
  isMobile = false;

  initializeTooltips(): void {
    setTimeout(() => {
      this.tooltips.forEach((tooltip) => tooltip.destroy());
      this.tooltips.clear();
      this.initTooltip(
        'signup',
        this.signupCondition,
        'signup-tooltip',
        'signup-trigger',
        'bottom'
      );
      this.initTooltip(
        'login',
        this.loginCondition,
        'login-tooltip',
        'login-trigger',
        'bottom'
      );
      this.initTooltip(
        'accountRecovery',
        this.accountRecoveryCondition,
        'account-recovery-tooltip',
        'mach-core-login-flyout-details',
        'bottom'
      );
    }, 0);
  }

  initTooltip(
    key: string,
    condition: boolean,
    id: string,
    trigger: string,
    position: 'top' | 'bottom'
  ): void {
    if (
      !condition ||
      this.tooltips.has(key) ||
      !this.checkToolTip(id, trigger)
    ) {
      return;
    }
    const tooltip = new Tooltip({
      id,
      positions: position,
      positionElement: trigger,
      triggerEvent: 'toggle',
      closeOnScroll: this.isMobile,
      offset: 4
    });
    this.tooltips.set(key, tooltip);
    tooltip.scheduleOpen(1000);
  }

  private checkToolTip(id: string, trigger: string): boolean {
    return !!(document.getElementById(id) && document.getElementById(trigger));
  }

  scheduleAutoClose(keys: string[], duration: number): void {
    this.clearAutoClose();
    this.autoCloseTimer = setTimeout(() => {
      keys.forEach((key) => this.closeTooltip(key));
    }, duration);
  }

  clearAutoClose(): void {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = undefined;
    }
  }

  closeTooltip(key: string): void {
    this.tooltips.get(key)?.close();
  }

  hasTooltipContent(content: string | undefined): boolean {
    return !!content?.trim();
  }

  hasAccountRecoveryContent(
    content: Record<string, unknown> | undefined | null
  ): boolean {
    return !!content?.['label'];
  }

  closeAllTooltips(): void {
    this.tooltips.forEach((tooltip) => tooltip.close());
  }

  handleTooltipClose(key: string, event?: Event): void {
    event?.stopPropagation();
    this.closeTooltip(key);
  }

  handleMobileAutoClose(): void {
    if (this.isMobile && (this.signupCondition || this.loginCondition)) {
      this.scheduleAutoClose(['signup', 'login'], 5000);
    }
  }

  ngOnDestroy(): void {
    this.clearAutoClose();
    this.tooltips.forEach((tooltip) => tooltip.destroy());
    this.tooltips.clear();
  }
}
